
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_32007_149848)"}},[_c('path',{attrs:{"d":"M14.94 3.075a1.001 1.001 0 011.09.215l2 2a.998.998 0 010 1.413l-2 2a.996.996 0 01-1.09.216 1 1 0 01-.62-.925V7h-1a.993.993 0 00-.8.4l-1.325 1.765L9.945 7.5l.975-1.3a2.997 2.997 0 012.4-1.2h1V4c0-.403.244-.769.62-.925zm-7.495 7.76l1.25 1.665-.975 1.3a2.997 2.997 0 01-2.4 1.2h-2a.999.999 0 110-2h2a.993.993 0 00.8-.4l1.325-1.766zm8.582 5.874a1 1 0 01-1.71-.71v-1h-.997a2.997 2.997 0 01-2.4-1.2l-4.8-6.4a.993.993 0 00-.8-.4h-2a.999.999 0 110-2h2c.944 0 1.835.445 2.4 1.2l4.8 6.4c.188.254.485.4.8.4h1v-1a1.004 1.004 0 011.71-.709l2 2a.998.998 0 010 1.413l-2 2-.003.006z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_32007_149848"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2.32 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    